module.exports = __webpack_public_path__ + "static/media/aaron.afaec2fe.jpeg";